import ReactDataTable from './ReactDataTable';

export default ReactDataTable;
